module.exports = __webpack_public_path__ + "static/media/fe253f0a-2541-43e6-b03d-8cc7d70fa576.010a3ca1.JPG";